import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, useMediaQuery, useTheme, Box, Typography, IconButton, Button, TableHead, TextField, Modal, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '../../common/assests/addmsglogo.png';

import Adminimg from '../../common/assests/adminimg.png';
import Paginations from '../../common/pagination/Paginations';
import NotificationModal from './NotificationModal';
import './PushNotification.css';
import NotificationRow from '../../common/tablerow/NotificationRow';
import TableComp from '../../common/tablecomp/TableComp';
import { createNotificationApi, deleteNotification, getAllNotificationApi, notificationByIdApi, updateNotification } from '../../api';
import { useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

const PushNotification = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const isSmallScreen = useMediaQuery('(max-width:480px)');

  const [notificationData, setNotificationData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [notificationByIdData,setNotificationByIdData]=useState({});


  const handleAllNotification = async () => {
    try {
      setLoading(true);
      const response = await getAllNotificationApi({
        token,
        currentPage,
      });
      // console.log("notification response",response.data);
      setNotificationData(response?.data || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
    }
  };


  const handledeleteNotification=async(id)=>{
    const isConfirmed = window.confirm(
      "Are you sure, you want to Delete  this notification?"
    );
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await deleteNotification({token,id})
      toast.success(response?.message)
      setChange(!change);
    } catch (error) {
      if (error?.status === 500) {
        toast.error("Some error occured");
      } else {
        toast.error(error?.error);
      }
      console.log("error", error);
    }
  }




  const handleAddNotification = async (data) => {
    try {
      // Validate required fields
      // if (!data.title) {
      //   toast.warning("All Fields are  required");
      //   return;
      // }
  
      if (!data.notificationDate || !data?.time ) {
        toast.warning("Please select a Notification Date and Time.");
        return;
      }
      if(data.selectedType1=="Notification"){
        
        if (!data.picture) {
          toast.warning("Please select a Image");
          return;
        }
      }
  
      // if (!data.sendTo) {
      //   toast.warning("Please specify the U.");
      //   return;
      // }
      if (data.selectedType1 === "Notification" && (!data.title || !data.description)) {
        toast.warning("Title and Description are required for Notifications.");
        return;
      }
  
      if (data.selectedType === "Selected Users" && (!data.recipients || data.recipients.length === 0)) {
        toast.warning("Please select at least one user/vender.");
        return;
      }
  
      if (data.selectedType1 === "Email" && !data.description) {
        toast.warning("Please provide a Description for the email.");
        return;
      }
  
    
      const formData = new FormData();
  
    
      const formattedDate = dayjs(data.notificationDate).format('YYYY-MM-DD');
      const formattedTime = data.time || '00:00:00';
  
    
      formData.append('sendTo', data.sendTo);
      formData.append('notificationDate', formattedDate);
      formData.append('notificationTime', formattedTime);
      formData.append('title', data.title);
      formData.append('description', data.description);
      formData.append('sendNotification', data.selectedType);
      formData.append('notificationType', data.selectedType1);
  
      if (data.selectedType === `Selected Users`) {
        formData.append('recipients', JSON.stringify(data.recipients));
      }
  
      if (data.picture) {
        formData.append('picture', data.picture);
      }
  
      // API Call
      const response = await createNotificationApi({ token, formData });
      toast.success(response?.message);
      setChange(!change);
      setOpen(false);
    } catch (error) {
      // Handle error responses
      if (error?.status === 500) {
        toast.error('Make Sure date and time are properly filled !');
      } else {
        toast.error(error?.error);
      }
      console.error('Error:', error);
    }
  };
  
  
  
const handleEditNotification=async(id)=>{
  try {
    setLoading(true);
    const response = await notificationByIdApi({
      token,
      id,
    });
    // console.log("notification by id response",response);
    setNotificationByIdData(response?.data || {});
    setLoading(false);
    setOpen(true);
  } catch (error) {
    setLoading(false);
    console.log("Error", error);
  }
}
// console.log("12345",notificationByIdData);

const handleUpdateNotification = async (data) => {
  // console.log("12345",data,notificationByIdData);
  if (!data.notificationDate || !data?.time ) {
    toast.warning("Please select Notification date and new time.");
    return;
  }

  // if (!data.sendTo) {
  //   toast.warning("Please specify the U.");
  //   return;
  // }
  if (data.selectedType1 === "Notification" && (!data.title || !data.description)) {
    toast.warning("Title and Description are required for Notifications.");
    return;
  }

  if (data.selectedType === "Selected Users" && (!data.recipients || data.recipients.length === 0)) {
    toast.warning("Please select at least one user/vender.");
    return;
  }

  if (data.selectedType1 === "Email" && !data.description ) {
    toast.warning("Please provide a Description for the email.");
    return;
  }
  
  try {
    const formData = new FormData();

    const formattedDate = dayjs(data.notificationDate).format('YYYY-MM-DD');
    const formattedTime = data.time || '00:00:00';

    formData.append('sendTo', data.sendTo);
    formData.append('notificationDate', formattedDate);
    formData.append('notificationTime', formattedTime);
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('sendNotification', data.selectedType);
    formData.append('notificationType', data.selectedType1);

    if (data.selectedType === 'Selected Users') {
      formData.append('recipients', JSON.stringify(data.recipients));
    }

    if (data.picture) {
      formData.append('picture', data.picture);
    }

    const response = await updateNotification({
      token,
      id: notificationByIdData?._id,
      formData,
    });
    
    // console.log("hj",response);

    toast.success(response?.message);
    setChange(!change);
    setOpen(false);
  } catch (error) {
    toast.error(error?.error || 'An error occurred.');
  }
};






  useEffect(() => {
    handleAllNotification();
  }, [currentPage, change]);


  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

 
  const handleOpenModal = (data) => {
    setEditingData(data);
    // setEditingData(data);
    setNotificationByIdData(data);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setEditingData(null);
    setNotificationByIdData(null);
  };

  

  const titles = [
    { title: "Sr. No" },
    { title: "Send to" },
    { title: "Notification Title" },
    { title: "Notification Type" },
    { title: " Image" },
    { title: "Status" },
    { title: "Push Date" },
    { title: " Action" },
  ];

  return (
    <div>
    {loading ? (
      <Loader variant="table" />

    ):(

      <Card
        backgroundColor={"#fff"}
        borderRadius={"35px"}
        w={"100%"}
        h={"auto"}
        sx={{ padding: "20px", borderRadius: "25px" ,marginBottom:'10px'}}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            flexWrap:'wrap'
          }}
        >
          <Typography
            sx={{ fontSize: "20px", fontWeight: "600", color: "#362B24" }}
          >
           All Push Notification
          </Typography>
          <Button
            onClick={() => handleOpenModal(null)}
            sx={{
              borderRadius: '29px',
              background: 'linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)',
              boxShadow: '1px 2px 30px 0px rgba(0, 0, 0, 0.06)',
              width: '235px',
              height: '58px',
              color: 'white',
              display: 'flex',
              gap: '5px',
              textTransform: 'none',
              fontSize: isSmallScreen ? '12px' : '16px',
              alignItems: 'center',
              '@media (max-width:600px)': {
                width: '200px',
                height: '50px',
                fontSize: '10px',
                gap: '2px', 
              },
            }}
          >
            <img
              src={AddIcon}
              alt="Add"
              style={{
                height: isSmallScreen ? '20px' : '24px',
                width: isSmallScreen ? '20px' : '24px',
                marginRight: isSmallScreen ? '1px' : '3px', 
              }}
            />
            Create New Notification
          </Button>
        
        </Box>

        <TableComp title={titles}>
          {notificationData.length > 0 ? (
            notificationData.map((item,index) => (
              <NotificationRow
                key={item?._id}
                row={item}
                index={(currentPage - 1) * 10 + index}
                handleModal={() => handleOpenModal(item)}
                ddeleteNotifcationelete={()=>handledeleteNotification(item?._id)}
                editData={()=>handleEditNotification(item?._id)}
              />
           )) 
        ) : ( 
            <TableRow>
              <TableCell colSpan={titles.length} align="center">
                No Data Found
              </TableCell>
            </TableRow>
         )} 
        </TableComp>
        <Paginations
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            disabled={loading}
          />
      </Card>
    )}

  <NotificationModal
    open={open}
    onClose={handleCloseModal}
    editingData={notificationByIdData}
    onSave={notificationByIdData ? handleUpdateNotification : handleAddNotification }
  />
    </div>
  );
};

export default PushNotification;
